export enum BEST_FOOD_CATEGORY {
  F16 = '한식',
  F07 = '양식',
  F12 = '중식',
  F10 = '일식',
  F04 = '분식',
  F14 = '커피/음료',
  F15 = '패스트푸드',
}
export const CONST_BEST_FOOD_CATEGORY = Object.values(BEST_FOOD_CATEGORY);
